import React from 'react';

export type ResetableComponentProps = {
  /** Function to reset the component state by remounting it */
  reset: () => void;
};

// HOC to inject a reset function that will remount the component when called
export default function injectResetable<T>(
  Component: React.ComponentType<T & ResetableComponentProps>
): React.FC<T> {
  return function ResetableComponent(props: T) {
    const [resetKey, setResetKey] = React.useState(0);

    const reset = React.useCallback(() => {
      setResetKey((prevKey) => prevKey + 1);
    }, []);

    return <Component {...props} reset={reset} key={resetKey} />;
  };
}
